// @ts-nocheck
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const borderWidth = pxToRem(1);
const borderCss = css`
    ${({ theme }) => `${borderWidth} solid ${resolveColor("common.border", theme)}`}
`;

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        padding: ${pxToRem(15, 0)};
        background-color: transparent;
        border: none;
        border-top: ${borderCss};
        border-bottom: ${borderCss};
        color: inherit;
        transition: ${transitionHoverStyles("color")};

        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.base};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &[aria-expanded="true"] {
            border-bottom-color: transparent;
        }

        &:hover {
            color: ${getColor("primary.main")};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

export const accordionFooterSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            ${_headerButtonStyles()}
            background-color: transparent;

            ${AccordionSectionPanel} + && {
                ${_headerButtonStyles()}
                margin-top: -${borderWidth};
            }

            /* Store Custom Code - Start */
            &:first-child button {
                border-top: 0;
                padding-top: 0;
            }

            /* Store Custom Code - End */
        `,
    },
    panelProps: {
        css: css`
            padding: ${pxToRem(5, 0, 17)};
            border: none;
            border-bottom: ${borderCss};
        `,
    },
    /* Store Custom Code - Start */
    titleTypographyProps: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.base};
        `,
    },
    toggleIconProps: {
        color: "primary",
    },
    /* Store Custom Code - End */
};
